import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Stamp } from "@/components/Doc";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sid = params.get("session_id");
  const [state, setState] = useState({ status: "checking" });
  const tries = useRef(0);

  useEffect(() => {
    if (!sid) { setState({ status: "missing" }); return; }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sid}`);
        if (data.payment_status === "paid") {
          setState({ status: "paid", ...data });
          if (data.authorize_url) { sessionStorage.setItem("lh_client_token", new URLSearchParams(data.authorize_url.split("?")[1]).get("token")); timer = setTimeout(() => navigate(data.authorize_url), 2500); }
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) { setState({ status: data.payment_status }); return; }
      } catch (e) { /* keep polling */ }
      if (tries.current++ < 8) timer = setTimeout(poll, 2000); else setState({ status: "timeout" });
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, navigate]);

  return (
    <main className="max-w-xl mx-auto px-5 py-28 text-center" data-testid="payment-success-page">
      {state.status === "paid" ? (
        <div className="settle">
          <Stamp color="red" rotate={-5} size="lg" testId="payment-stamp">{state.kind === "watch" ? "Card Stored" : "Paid"}</Stamp>
          {state.kind === "watch" ? (
            <>
              <h1 className="t-head text-4xl mt-8">Subscription created. Not yet billing.</h1>
              <p className="t-body text-lg mt-4">Next: a short authorization step for {state.legal_name}. Taking you there now…</p>
              <Link to={state.authorize_url} className="btn btn-stamp mt-8" data-testid="go-authorize-btn">Complete Authorization →</Link>
            </>
          ) : (
            <>
              <h1 className="t-head text-4xl mt-8">Findings Review booked.</h1>
              <p className="t-body text-lg mt-4">Thank you. Someone from the firm will write within one business day to fix the ninety minutes. Your payment is credited in full against any installation booked within ninety days.</p>
              <Link to="/" className="btn mt-8" data-testid="review-home-btn">Return to the site</Link>
            </>
          )}
        </div>
      ) : ["checking"].includes(state.status) ? (
        <p className="t-label text-olive" data-testid="payment-checking">Confirming with Stripe…</p>
      ) : (
        <div>
          <h1 className="t-head text-4xl">Payment not confirmed.</h1>
          <p className="t-body text-lg mt-4 text-olive">Status: {state.status}. If your card was charged, reply to the receipt email and we'll sort it by hand.</p>
          <Link to="/pricing" className="btn mt-8">Back to the rate schedule</Link>
        </div>
      )}
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main className="max-w-xl mx-auto px-5 py-28 text-center" data-testid="payment-cancel-page">
      <Stamp color="carbon" rotate={4} size="lg">Not Filed</Stamp>
      <h1 className="t-head text-4xl mt-8">Checkout cancelled.</h1>
      <p className="t-body text-lg mt-4 text-olive">Nothing was stored and nothing was charged.</p>
      <Link to="/pricing" className="btn mt-8" data-testid="cancel-back-btn">Back to the rate schedule</Link>
    </main>
  );
}
